import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, Transition as _Transition } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = { class: "d-flex" };
const _hoisted_7 = { class: "checkbox-aligned-buttons" };
const _hoisted_8 = {
    key: 0,
    class: "form-contents"
};
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_11 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = { class: "clearfix" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_16 = { class: "clearfix" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_19 = { class: "clearfix" };
const _hoisted_20 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_21 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_22 = { class: "clearfix" };
const _hoisted_23 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_24 = { class: "float-end" };
const _hoisted_25 = { id: "current" };
const _hoisted_26 = { id: "maximum" };
const _hoisted_27 = {
    key: 0,
    class: "clearfix card"
};
const _hoisted_28 = { class: "clearfix card-header" };
const _hoisted_29 = { class: "d-flex float-start" };
const _hoisted_30 = { style: { "margin-top": "2px" } };
const _hoisted_31 = { class: "float-end" };
const _hoisted_32 = {
    key: 0,
    class: "clearfix card-body p-0"
};
const _hoisted_33 = { class: "card bg-white data-grid event-alarms-grid overflow-x-auto m-0" };
const _hoisted_34 = { class: "table table-hover bottom0 border-collapse-separate" };
const _hoisted_35 = { class: "text-end" };
const _hoisted_36 = {
    key: 1,
    class: "clearfix card"
};
const _hoisted_37 = { class: "card-body" };
const _hoisted_38 = { style: { "margin-top": "2px" } };
const _hoisted_39 = { class: "mt-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_textarea = _resolveComponent("b-form-textarea");
    const _component_router_link = _resolveComponent("router-link");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", {
                    class: _normalizeClass({ 'red-text': _ctx.isLogArchived })
                }, _toDisplayString(_ctx.pageTitle), 3 /* TEXT, CLASS */)
            ]),
            _cache[17] || (_cache[17] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_b_form_checkbox, {
                                class: "ms-2",
                                style: { "padding-top": "8px" },
                                modelValue: _ctx.log.notifySiteContactGroup,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.log.notifySiteContactGroup) = $event)),
                                size: "lg"
                            }, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\tNotify\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"])
                        ])), [
                            [_directive_standard_or_higher]
                        ]),
                        _cache[13] || (_cache[13] = _createTextVNode()),
                        _createVNode(_component_b_button, {
                            class: "ms-2",
                            type: "button",
                            variant: "primary",
                            onClick: _ctx.save,
                            disabled: _ctx.hasNoSystems
                        }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick", "disabled"]),
                        _cache[14] || (_cache[14] = _createTextVNode()),
                        (!_ctx.isNewLog && !_ctx.isLogArchived)
                            ? (_openBlock(), _createBlock(_component_b_button, {
                                key: 0,
                                class: "ms-2",
                                type: "button",
                                variant: "danger",
                                onClick: _ctx.archive
                            }, {
                                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Archive", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]))
                            : _createCommentVNode("v-if", true),
                        _cache[15] || (_cache[15] = _createTextVNode()),
                        (!_ctx.isNewLog && _ctx.isLogArchived)
                            ? (_openBlock(), _createBlock(_component_b_button, {
                                key: 1,
                                class: "ms-2",
                                type: "button",
                                variant: "warning",
                                onClick: _ctx.restore
                            }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                        _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Restore", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]))
                            : _createCommentVNode("v-if", true),
                        _cache[16] || (_cache[16] = _createTextVNode()),
                        _createVNode(_component_b_button, {
                            class: "ms-2",
                            type: "button",
                            variant: "secondary",
                            onClick: _ctx.goBack
                        }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                    _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ])
        ]),
        _cache[69] || (_cache[69] = _createTextVNode()),
        (_ctx.loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"])
                    ]),
                    _cache[67] || (_cache[67] = _createTextVNode()),
                    (_ctx.hasNoSystems)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_b_alert, {
                                "model-value": true,
                                variant: "warning"
                            }, {
                                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\tYou do not have access to any system, or no system has been added yet. A comment cannot be created until a system is available.\r\n\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[68] || (_cache[68] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_CollapsibleForm, null, {
                            default: _withCtx(() => [
                                _createElementVNode("fieldset", { disabled: _ctx.hasNoSystems }, [
                                    _withDirectives(_createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _cache[20] || (_cache[20] = _createElementVNode("label", null, "Company", -1 /* CACHED */)),
                                            _cache[21] || (_cache[21] = _createTextVNode()),
                                            _createVNode(_component_multiselect, {
                                                name: "company",
                                                modelValue: _ctx.company,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.company) = $event)),
                                                options: _ctx.companies,
                                                "track-by": "companyId",
                                                label: "companyName",
                                                showLabels: false,
                                                placeholder: "All companies"
                                            }, {
                                                noResult: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "options"])
                                        ])
                                    ], 512 /* NEED_PATCH */), [
                                        [_vShow, _ctx.companies && _ctx.companies.length > 1]
                                    ]),
                                    _cache[62] || (_cache[62] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                            _cache[23] || (_cache[23] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tSystem *\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[24] || (_cache[24] = _createTextVNode()),
                                            _createVNode(_component_multiselect, _mergeProps(_ctx.systemVal, {
                                                name: "system",
                                                modelValue: _ctx.system,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.system) = $event)),
                                                options: _ctx.visibleSystems,
                                                "track-by": "systemId",
                                                label: "displayName",
                                                showLabels: false,
                                                placeholder: "All systems",
                                                class: ['multiselect-small', _ctx.errors && _ctx.errors.system && _ctx.attemptedSave ? 'is-invalid' : '']
                                            }), {
                                                noResult: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 16 /* FULL_PROPS */, ["modelValue", "options", "class"])
                                        ]),
                                        _cache[28] || (_cache[28] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_18, [
                                            _cache[26] || (_cache[26] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tLocation\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[27] || (_cache[27] = _createTextVNode()),
                                            _createVNode(_component_multiselect, {
                                                modelValue: _ctx.component,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.component) = $event)),
                                                options: _ctx.systemComponents,
                                                "track-by": "componentId",
                                                label: "displayName",
                                                showLabels: false,
                                                placeholder: "All locations",
                                                class: "multiselect-small"
                                            }, {
                                                noResult: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "options"])
                                        ])
                                    ]),
                                    _cache[63] || (_cache[63] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                            _cache[30] || (_cache[30] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tType *\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[31] || (_cache[31] = _createTextVNode()),
                                            _createVNode(_component_multiselect, _mergeProps(_ctx.typeVal, {
                                                name: "logType",
                                                modelValue: _ctx.logType,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.logType) = $event)),
                                                options: _ctx.logTypesVisible,
                                                "track-by": "logTypeId",
                                                label: "logTypeName",
                                                showLabels: false,
                                                placeholder: "All types",
                                                class: ['multiselect-small', _ctx.errors && _ctx.errors.type && _ctx.attemptedSave ? 'is-invalid' : ''],
                                                disabled: _ctx.logTypeId > 2
                                            }), {
                                                noResult: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 16 /* FULL_PROPS */, ["modelValue", "options", "class", "disabled"])
                                        ]),
                                        _cache[36] || (_cache[36] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_21, [
                                            _cache[34] || (_cache[34] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tDate *\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[35] || (_cache[35] = _createTextVNode()),
                                            _createVNode(_component_b_input_group, {
                                                class: _normalizeClass(['clearfix bottom0', _ctx.errors && _ctx.errors.date && _ctx.attemptedSave ? 'is-invalid' : ''])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_flat_pickr, _mergeProps(_ctx.dateVal, {
                                                        name: "whenEntered",
                                                        modelValue: _ctx.log.whenEntered,
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.log.whenEntered) = $event)),
                                                        class: "form-control",
                                                        config: _ctx.datePickerConfig
                                                    }), null, 16 /* FULL_PROPS */, ["modelValue", "config"]),
                                                    _cache[33] || (_cache[33] = _createTextVNode()),
                                                    _createVNode(_component_b_input_group_append, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_button, {
                                                                type: "button",
                                                                variant: "outline-secondary",
                                                                "data-toggle": ""
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                                                        _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            })
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["class"])
                                        ])
                                    ]),
                                    _cache[64] || (_cache[64] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, [
                                            _cache[38] || (_cache[38] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tComment *\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[39] || (_cache[39] = _createTextVNode()),
                                            _createVNode(_component_b_form_textarea, _mergeProps(_ctx.commentVal, {
                                                name: "notes",
                                                modelValue: _ctx.log.notes,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.log.notes) = $event)),
                                                rows: "5",
                                                class: { 'is-invalid': _ctx.errors && _ctx.errors.comment && _ctx.attemptedSave },
                                                maxlength: _ctx.maxCommentLength
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "maxlength"]),
                                            _cache[40] || (_cache[40] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.getCommentLength), 1 /* TEXT */),
                                                _cache[37] || (_cache[37] = _createTextVNode()),
                                                _createElementVNode("span", _hoisted_26, "/ " + _toDisplayString(_ctx.maxCommentLength), 1 /* TEXT */)
                                            ])
                                        ])
                                    ]),
                                    _cache[65] || (_cache[65] = _createTextVNode()),
                                    (_ctx.divAlarmsVisible)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            _createElementVNode("div", _hoisted_28, [
                                                _createElementVNode("div", _hoisted_29, [
                                                    _cache[43] || (_cache[43] = _createElementVNode("h2", { class: "m-0 me-3" }, "Alarms", -1 /* CACHED */)),
                                                    _cache[44] || (_cache[44] = _createTextVNode()),
                                                    _createElementVNode("div", _hoisted_30, [
                                                        _cache[41] || (_cache[41] = _createElementVNode("label", { class: "m-0" }, "Active: ", -1 /* CACHED */)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.getActiveAlarmsCount()) + " |\r\n\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                        _cache[42] || (_cache[42] = _createElementVNode("label", { class: "m-0" }, " Total: ", -1 /* CACHED */)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.getTotalAlarmsCount()), 1 /* TEXT */)
                                                    ])
                                                ]),
                                                _cache[45] || (_cache[45] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("a", {
                                                        class: "collapse-link",
                                                        onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.alarmDetailsVisible = !_ctx.alarmDetailsVisible))
                                                    }, [
                                                        _createElementVNode("i", {
                                                            class: _normalizeClass(_ctx.alarmDetailsVisible ? 'fa fa-chevron-up' : 'fa fa-chevron-down')
                                                        }, null, 2 /* CLASS */)
                                                    ])
                                                ])
                                            ]),
                                            _cache[52] || (_cache[52] = _createTextVNode()),
                                            _createVNode(_Transition, { name: "slide" }, {
                                                default: _withCtx(() => [
                                                    (_ctx.alarmDetailsVisible)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                            _createElementVNode("div", _hoisted_33, [
                                                                _createElementVNode("table", _hoisted_34, [
                                                                    _cache[50] || (_cache[50] = _createElementVNode("thead", null, [
                                                                        _createElementVNode("tr", null, [
                                                                            _createElementVNode("th", { class: "alarm-border" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tTime\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),
                                                                            _createTextVNode(),
                                                                            _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tLocation\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),
                                                                            _createTextVNode(),
                                                                            _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDescription\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),
                                                                            _createTextVNode(),
                                                                            _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tState\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),
                                                                            _createTextVNode(),
                                                                            _createElementVNode("th", { class: "text-end" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tValue\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                        ])
                                                                    ], -1 /* CACHED */)),
                                                                    _cache[51] || (_cache[51] = _createTextVNode()),
                                                                    _createElementVNode("tbody", null, [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.log.alarms, (item) => {
                                                                            return (_openBlock(), _createElementBlock("tr", {
                                                                                class: _normalizeClass(['alarm', _ctx.alarmClass(item)])
                                                                            }, [
                                                                                _createElementVNode("td", null, [
                                                                                    _createVNode(_component_router_link, {
                                                                                        to: { name: 'alarms', query: { 'alarmId': item.alarmId } },
                                                                                        class: "blue"
                                                                                    }, {
                                                                                        default: _withCtx(() => [
                                                                                            _createTextVNode(_toDisplayString(_ctx.formatDateTime(item.whenRaised)), 1 /* TEXT */)
                                                                                        ]),
                                                                                        _: 2 /* DYNAMIC */
                                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                                                                ]),
                                                                                _cache[46] || (_cache[46] = _createTextVNode()),
                                                                                _createElementVNode("td", null, _toDisplayString(item.componentName), 1 /* TEXT */),
                                                                                _cache[47] || (_cache[47] = _createTextVNode()),
                                                                                _createElementVNode("td", null, _toDisplayString(item.alarmDefinitionName), 1 /* TEXT */),
                                                                                _cache[48] || (_cache[48] = _createTextVNode()),
                                                                                _createElementVNode("td", null, _toDisplayString(_ctx.getAlarmState(item)), 1 /* TEXT */),
                                                                                _cache[49] || (_cache[49] = _createTextVNode()),
                                                                                _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.getAlarmValue(item)), 1 /* TEXT */)
                                                                            ], 2 /* CLASS */));
                                                                        }), 256 /* UNKEYED_FRAGMENT */))
                                                                    ])
                                                                ])
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[66] || (_cache[66] = _createTextVNode()),
                                    (_ctx.divEventVisible)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                            _cache[60] || (_cache[60] = _createElementVNode("div", { class: "clearfix card-header" }, [
                                                _createElementVNode("h2", { class: "m-0 me-3" }, "Alarm Event")
                                            ], -1 /* CACHED */)),
                                            _cache[61] || (_cache[61] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_37, [
                                                _createElementVNode("div", _hoisted_38, [
                                                    _createElementVNode("div", null, [
                                                        _cache[53] || (_cache[53] = _createElementVNode("label", { class: "m-0" }, "Event Type: ", -1 /* CACHED */)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.log.event.eventTypeName), 1 /* TEXT */)
                                                    ]),
                                                    _cache[57] || (_cache[57] = _createTextVNode()),
                                                    _createElementVNode("div", null, [
                                                        _cache[54] || (_cache[54] = _createElementVNode("label", { class: "m-0" }, "When first alarm was raised: ", -1 /* CACHED */)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.log.event.whenFirstAlarmRaised)), 1 /* TEXT */)
                                                    ]),
                                                    _cache[58] || (_cache[58] = _createTextVNode()),
                                                    _createElementVNode("div", null, [
                                                        _cache[55] || (_cache[55] = _createElementVNode("label", { class: "m-0" }, "When last alarm was raised: ", -1 /* CACHED */)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.log.event.whenLastAlarmRaised)), 1 /* TEXT */)
                                                    ]),
                                                    _cache[59] || (_cache[59] = _createTextVNode()),
                                                    _createElementVNode("div", _hoisted_39, [
                                                        _createVNode(_component_router_link, {
                                                            to: { name: 'events', params: { 'eventId': _ctx.log.event.eventId } },
                                                            class: "blue"
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tView Alarm Event\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                ]))]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["to"])
                                                    ])
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ], 8 /* PROPS */, _hoisted_13)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _cache[70] || (_cache[70] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Wait..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
